var exports = {
  "n": "ShopMessagePreview.module__panel___Mm9wQl",
};

module.exports = exports;
